import { StyleSheet } from 'aphrodite';

export default StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
  },
  left: {
    flex: 1,
    height: '100%',
    overflow: 'auto',
    boxSizing: 'border-box',
    alignItems: 'flex-end',
    padding: '40px 40px 40px 20px',
  },
  right: {
    flex: 1,
    height: '100%',
    overflow: 'auto',
    boxSizing: 'border-box',
    backgroundColor: '#F6F8F9',
    padding: '40px 20px 40px 40px',
  },
  width: {
    width: '510px',
  },
  marginBottom: {
    marginBottom: '40px',
  },

  direction: {
    color: '#32363A',
    fontSize: '16px',
    lineHeight: '24px',
    margin: '20px 0 35px',
  },
  raw: {
    width: '550px',
    backgroundColor: '#F6F8F9',
    padding: '20px 32px',
    color: '#32363A',
    fontSize: '18px',
    lineHeight: '26px',
  },

  title: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: '20px',
  },
  icon: {
    width: '4px',
    height: '14px',
    backgroundColor: '#3399FF',
    marginRight: '8px',
  },
  text: {
    flex: 1,
    color: '#32363A',
    fontSize: '16px',
    lineHeight: '24px',
  },
});



// WEBPACK FOOTER //
// ./src/components/report/base_report/follow_up_report/styles.js